<template>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-start">
            <svg class="w-5 h-5 shrink-0 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
            <span class="underline">Téléphone:</span>
        </div>
        <span v-if="contactSettings.phone" class="text-sky">{{ "+"+contactSettings.dial_code+" "+contactSettings.phone }}</span>
        <span v-else class="text-sky">Non renseigné</span>
    </li>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-start">
            <i class="fab fa-whatsapp text-lg mr-1"></i>
            <span class="underline">WhatsApp:</span>
        </div>
        <span v-if="contactSettings.wa_phone" class="text-sky">{{ "+"+contactSettings.wa_dial_code+" "+contactSettings.wa_phone }}</span>
        <span v-else class="text-sky">Non renseigné</span>
    </li>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-start">
            <svg class="h-5 w-5 shrink-0 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span class="underline">Adresse mail:</span>
        </div>
        <span class="text-sky">{{ contactSettings.email }}</span>
    </li>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-start">
            <svg class="h-5 w-5 shrink-0 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20" />
            </svg>
            <span class="underline">Adresse:</span>
        </div>
        <span class="text-sky">{{ contactSettings.address ? contactSettings.address : 'Non renseignée' }}</span>
    </li>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-start">
            <i class="fab fa-facebook text-lg mr-1"></i>
            <span class="underline">Facebook:</span>
        </div>
        <span class="text-sky">
            <a :href="this.contactSettings.facebook_link">
                {{ contactSettings.facebook_link ? contactSettings.facebook_link : 'Non renseigné' }}
            </a>
        </span>
    </li>
    <li class="text-sm w-full flex justify-between py-2 border-b border-gray-200 font-bold text-gray-600">
        <div class="flex items-start">
            <i class="fab fa-linkedin text-lg mr-1"></i>
            <span class="underline">Linkedin:</span>
        </div>
        <span class="text-sky">
            <a :href="this.contactSettings.linkedin_link">
                {{ contactSettings.linkedin_link ? contactSettings.linkedin_link : 'Non renseigné' }}
            </a>
        </span>
    </li>
</template>

<script>
    export default {
        props: {
            contactSettings: Object
        },
    }
</script>
